"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyService = void 0;
var loyalty_1 = require("../models/loyalty");
var api_1 = require("./api");
var PATH = '/loyalty/api';
var PATH_V1 = '/loyalty/api/v1';
var RELAY_PATH = '/relay/api';
var PATH_V2 = '/loyalty/api/v2';
var expandUserPoints = function (payload) {
    if (!payload) {
        return null;
    }
    var id = payload.id, activities = payload.activities, redeemablePoints = payload.redeemable_points, totalPoints = payload.total_points;
    return { id: id, activities: activities, redeemablePoints: redeemablePoints, totalPoints: totalPoints };
};
var LoyaltyService = /** @class */ (function () {
    function LoyaltyService() {
    }
    LoyaltyService.getUserPoints = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/user/points"
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, expandUserPoints(response)];
                    case 2:
                        e_1 = _a.sent();
                        throw e_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.getUserRewards = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/user/rewards"
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, loyalty_1.Reward.JsonToRewards(response)];
                    case 2:
                        e_2 = _a.sent();
                        throw e_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.getUserActivities = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/activity/user"
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, loyalty_1.Activity.JsonToActivities(response)];
                    case 2:
                        e_3 = _a.sent();
                        throw e_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.getActivities = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH_V1 + "/activities"
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, loyalty_1.Activity.JsonToActivities(response)];
                    case 2:
                        e_4 = _a.sent();
                        throw e_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.getRewardCategories = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/reward/categories"
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_5 = _a.sent();
                        throw e_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.getCampaign = function (activityId) {
        return __awaiter(this, void 0, void 0, function () {
            var e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/activity/campaign?activity_id=" + activityId
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_6 = _a.sent();
                        throw e_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.postUserCodeCampaign = function (codeSubmit, campaignId, campaignGroupId) {
        return __awaiter(this, void 0, void 0, function () {
            var e_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!campaignId && !campaignGroupId)
                            return [2 /*return*/, new Error('Invalid Code Submission')];
                        return [4 /*yield*/, api_1.API.post({
                                url: PATH + "/user/code/submit",
                                body: { campaignId: campaignId, campaignGroupId: campaignGroupId, codeValue: codeSubmit }
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_7 = _a.sent();
                        throw e_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.creditUserPoints = function (activityId) {
        return __awaiter(this, void 0, void 0, function () {
            var e_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.post({
                                url: RELAY_PATH + "/user/credit",
                                body: { activityId: activityId }
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_8 = _a.sent();
                        throw e_8;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.creditUserPointsV1 = function (activityId, headers) {
        return __awaiter(this, void 0, void 0, function () {
            var e_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.post({
                                url: PATH_V1 + "/activities/credit",
                                body: { activityId: activityId },
                                headers: __assign({}, headers)
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_9 = _a.sent();
                        throw e_9;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.getRewards = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/rewards?activeOnly=1"
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, loyalty_1.Reward.JsonToRewards(response)];
                    case 2:
                        e_10 = _a.sent();
                        throw e_10;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.getReward = function (rewardId) {
        return __awaiter(this, void 0, void 0, function () {
            var e_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({ url: PATH + "/rewards/" + rewardId })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_11 = _a.sent();
                        throw e_11;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.redeemReward = function (rewardId, quantity) {
        return __awaiter(this, void 0, void 0, function () {
            var e_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.post({
                                url: RELAY_PATH + "/user/reward/redeem",
                                body: { rewardId: rewardId, quantity: quantity }
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_12 = _a.sent();
                        throw e_12;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.redeemRewardFromLoyalty = function (rewardId, quantity) {
        return __awaiter(this, void 0, void 0, function () {
            var e_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.post({
                                url: PATH + "/user/rewards/redeem",
                                body: { rewardId: rewardId, quantity: quantity }
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_13 = _a.sent();
                        throw e_13;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.getSurvey = function (activityId) {
        return __awaiter(this, void 0, void 0, function () {
            var survey, surveyPostResponse, e_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/activity/survey?activity_id=" + activityId
                            })];
                    case 1:
                        survey = _a.sent();
                        surveyPostResponse = {
                            surveyId: survey.id,
                            responses: survey.questions.map(function (question) { return ({
                                id: question.id,
                                value: null
                            }); })
                        };
                        return [2 /*return*/, { survey: survey, surveyPostResponse: surveyPostResponse }];
                    case 2:
                        e_14 = _a.sent();
                        throw e_14;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.getSurveyResponse = function (activityId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, userResponses, e_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/activity/survey/result?survey_id=" + activityId
                            })];
                    case 1:
                        response = _a.sent();
                        userResponses = response && response[0] ? response[0].survey_responses : [];
                        userResponses.map(function (question) { return ({
                            id: question.id,
                            value: question.value
                        }); });
                        return [2 /*return*/, userResponses];
                    case 2:
                        e_15 = _a.sent();
                        throw e_15;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.fetchRewardEntryDetails = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var url, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = PATH + "/user/reward/entries/" + id;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_1 = _a.sent();
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.postSurvey = function (surveyPostResponse) {
        return __awaiter(this, void 0, void 0, function () {
            var e_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.post({
                                url: RELAY_PATH + "/activity/survey",
                                body: surveyPostResponse
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_16 = _a.sent();
                        throw e_16;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.postSurveyV1 = function (surveyPostResponse) {
        return __awaiter(this, void 0, void 0, function () {
            var e_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.post({
                                url: PATH_V1 + "/survey",
                                body: surveyPostResponse
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_17 = _a.sent();
                        throw e_17;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.uploadPhoto = function (activityId, _a, cancelToken, onUploadProgress, onSuccess, onError) {
        var file = _a.file;
        var body = new FormData();
        body.append('activityId', activityId);
        body.append('multipartFile', file);
        var source = api_1.API.createCancelToken();
        api_1.API.post({
            url: PATH + "/activity/user/upload-photo",
            contentType: 'multipart/form-data',
            body: body,
            onUploadProgress: onUploadProgress,
            cancelToken: source.token
        })
            .then(function (response) {
            onSuccess(response);
        })
            .catch(function (error) {
            onError(error);
        });
        cancelToken.cancel = source.cancel;
    };
    LoyaltyService.getActivity = function (activityId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_18;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/user/activity/" + activityId
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, loyalty_1.Activity.JsonToActivity(response)];
                    case 2:
                        e_18 = _a.sent();
                        throw e_18;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.getActivityByKey = function (activityKey) {
        return __awaiter(this, void 0, void 0, function () {
            var e_19;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/activity/by-key/" + activityKey
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_19 = _a.sent();
                        throw e_19;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.getUserActivityByKey = function (activityKey) {
        return __awaiter(this, void 0, void 0, function () {
            var e_20;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/user/activity/by-key/" + activityKey
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_20 = _a.sent();
                        throw e_20;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.getActivityMappings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_21;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/activity/mappings"
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_21 = _a.sent();
                        throw e_21;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.getActivityMapping = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var e_22;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/activity/mappings/" + key
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_22 = _a.sent();
                        throw e_22;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.getPoll = function (activityId) {
        return __awaiter(this, void 0, void 0, function () {
            var e_23;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH_V1 + "/poll/" + activityId
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_23 = _a.sent();
                        throw e_23;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.submitPoll = function (pollResponse, activityId) {
        return __awaiter(this, void 0, void 0, function () {
            var e_24;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.post({
                                url: PATH_V1 + "/poll",
                                body: {
                                    pollResponse: pollResponse,
                                    pollId: activityId
                                }
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_24 = _a.sent();
                        throw e_24;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.getQuiz = function (activityId) {
        return __awaiter(this, void 0, void 0, function () {
            var e_25;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH_V1 + "/quiz/" + activityId
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_25 = _a.sent();
                        throw e_25;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.submitQuiz = function (quizResponse, activityId) {
        return __awaiter(this, void 0, void 0, function () {
            var e_26;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.post({
                                url: PATH_V1 + "/quiz",
                                body: {
                                    quiz_response: quizResponse,
                                    quizId: activityId
                                }
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_26 = _a.sent();
                        throw e_26;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.getSurveyV2 = function (activityId) {
        return __awaiter(this, void 0, void 0, function () {
            var e_27;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH_V2 + "/survey/" + activityId
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_27 = _a.sent();
                        throw e_27;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.getSurveyResultV2 = function (activityId) {
        return __awaiter(this, void 0, void 0, function () {
            var e_28;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH_V2 + "/survey/" + activityId + "/result"
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_28 = _a.sent();
                        throw e_28;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoyaltyService.submitSurveyV2 = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var e_29;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.post({
                                url: PATH_V2 + "/survey",
                                body: body
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_29 = _a.sent();
                        throw e_29;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return LoyaltyService;
}());
exports.LoyaltyService = LoyaltyService;
//# sourceMappingURL=loyalty-service.js.map